import React from 'react';
import { Shield } from 'lucide-react';
import { PRIVACY_POLICY_CONTENT } from '../../content/privacyPolicy';
import { LegalDocumentPage } from './LegalDocumentPage';

export function PrivacyPolicyPage() {
  const content = PRIVACY_POLICY_CONTENT;

  return (
    <LegalDocumentPage
      canonicalPath="/privacy"
      content={content}
      icon={Shield}
      keywords="privacy policy, vevi monster privacy, ai dubbing privacy, captions privacy, audio translation privacy"
      leadCompanyBlock={{
        title: content.controller.heading,
        intro: content.controller.intro,
        companyName: content.controller.companyName,
        companyDetails: content.controller.companyDetails,
        email: content.controller.email,
      }}
    />
  );
}
